import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withKeys as _withKeys, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "relatedAccountsForm" }
const _hoisted_2 = { class: "stepHeader absoluteTop" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("small", { class: "line" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "1", -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("small", { class: "line" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "2", -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "3", -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("hr", { class: "primaryShort" }, null, -1)
const _hoisted_13 = { class: "verificationStatus" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_alert icon" }, null, -1)
const _hoisted_15 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StepOne = _resolveComponent("StepOne")!
  const _component_StepTwo = _resolveComponent("StepTwo")!
  const _component_StepThree = _resolveComponent("StepThree")!
  const _component_ThankYou = _resolveComponent("ThankYou")!
  const _component_WheretoFind = _resolveComponent("WheretoFind")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("connected_accounts.add_title")), 1),
        (_ctx.step === 1 || _ctx.step === 2 || _ctx.step === 3)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
              _createElementVNode("li", {
                class: _normalizeClass({ completed: _ctx.step > 1, selected: _ctx.step === 1 })
              }, _hoisted_6, 2),
              _createElementVNode("li", {
                class: _normalizeClass({ completed: _ctx.step > 2, selected: _ctx.step === 2 })
              }, _hoisted_9, 2),
              _createElementVNode("li", {
                class: _normalizeClass({ selected: _ctx.step === 3 })
              }, _hoisted_11, 2)
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_12,
      (_ctx.step === 1)
        ? (_openBlock(), _createBlock(_component_StepOne, {
            key: 0,
            onSubmit: _ctx.setProvider
          }, null, 8, ["onSubmit"]))
        : _createCommentVNode("", true),
      (_ctx.step === 2)
        ? (_openBlock(), _createBlock(_component_StepTwo, {
            key: 1,
            onSubmit: _ctx.setCode,
            onPrevious: _cache[0] || (_cache[0] = ($event: any) => (_ctx.step--)),
            onShowHelp: _cache[1] || (_cache[1] = ($event: any) => (_ctx.step = 0))
          }, null, 8, ["onSubmit"]))
        : _createCommentVNode("", true),
      (_ctx.step === 3)
        ? (_openBlock(), _createBlock(_component_StepThree, {
            key: 2,
            onSubmit: _ctx.postUserCode,
            onPrevious: _cache[2] || (_cache[2] = ($event: any) => (_ctx.step--))
          }, null, 8, ["onSubmit"]))
        : _createCommentVNode("", true),
      (_ctx.step === 4)
        ? (_openBlock(), _createBlock(_component_ThankYou, {
            key: 3,
            onReset: _ctx.resetForm
          }, null, 8, ["onReset"]))
        : _createCommentVNode("", true),
      (_ctx.step === 0)
        ? (_openBlock(), _createBlock(_component_WheretoFind, {
            key: 4,
            onStep: _cache[3] || (_cache[3] = ($event: any) => (_ctx.step = 2))
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.display,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.display) = $event)),
      onHide: _ctx.resetForm,
      class: "successDialog",
      tabindex: "0"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("connected_accounts.problem")), 1)
        ]),
        _createVNode(_component_Button, {
          class: "defaultButton",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.display = false)),
          style: {"justify-content":"center"},
          tabindex: "0",
          onKeypress: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.display = false), ["enter"]))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("dialog.close")), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible", "onHide"])
  ], 64))
}